import React, { useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import Collections from "./Collections";
import Products from "./Products";
import { CircularProgressCustom } from "../common-components/CircularProgressCustom";
import { GET_CATEGORY_BY_FULL_NAME } from "../../../services/graphql-query";
import { useLazyQuery } from "@apollo/react-hooks";
import MainContext from "../../../context/Main";

export default function Categories({ categories }) {
    let params = useParams();
    const { totalProducts, totalCollections, totalCategories } =
        useContext(MainContext);

    const [
        getCategoriesFromUrlParams,
        { loading, error, data: categoriesFromUrlParams },
    ] = useLazyQuery(GET_CATEGORY_BY_FULL_NAME, {
        variables: {
            name: params.categoryName,
            totalProducts: totalProducts,
            totalCollections: totalCollections,
            totalCategories: totalCategories,
        },
    });
    useEffect(() => {
        if (
            totalProducts &&
            totalCollections &&
            totalCategories &&
            params.categoryName
        ) {
            getCategoriesFromUrlParams();
        }
    }, [totalProducts, totalCollections, totalCategories]);

    if (params.categoryName) {
        if (loading) return <CircularProgressCustom />;

        return (
            <>
                {categoriesFromUrlParams &&
                    categoriesFromUrlParams.categories.data.length === 0 && (
                        <h1>There is no such category</h1>
                    )}
                {categoriesFromUrlParams &&
                    categoriesFromUrlParams.categories.data.map((category, index) => {
                        return (
                            <div key={category.id} id={"catergory" + index}>
                                <h1 className="text-center">
                                    {category.attributes.name}
                                </h1>
                                {category.attributes.collections.data.map(
                                    (collection) => {
                                        return (
                                            <div key={collection.id}>
                                                <h2>
                                                    {collection.attributes
                                                        .products.data
                                                        .length !== 0 &&
                                                        collection.attributes
                                                            .name}
                                                </h2>
                                                <Products
                                                    products={
                                                        collection.attributes
                                                            .products.data
                                                    }
                                                />
                                            </div>
                                        );
                                    }
                                )}
                            </div>
                        );
                    })}
            </>
        );
    }
    return (
        <>
            {categories.map((category, index) => {
                return (
                    <div key={category.id} className="p-3" id={"category" + index}>
                        <h2>{category.attributes.name}</h2>
                        <Collections
                            category={category.attributes.name}
                            collections={category.attributes.collections.data}
                        />
                    </div>
                );
            })}
        </>
    );
}
